import { SurveyStatus } from "../../../redux/survey/survey.types";

const DASHBOARD_SURVEY_LIST_PAGE_SIZE = 12;
const FILTER_STATUS_LIST = [SurveyStatus.Live, SurveyStatus.Complete, SurveyStatus.Draft] as const;
type FilterStatus = typeof FILTER_STATUS_LIST[number];

export { FILTER_STATUS_LIST, DASHBOARD_SURVEY_LIST_PAGE_SIZE };
export type { FilterStatus };
